import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <section className="public-footer-brand">
          <h3>Maderas del Atlantico, S.A.</h3>
          <p>Fabricacion de palets certificados para exportacion y procesos industriales.</p>
        </section>

        <nav className="public-footer-links" aria-label="Enlaces del footer">
          <Link to="/">Inicio</Link>
          <Link to="/productos">Productos</Link>
          <Link to="/sobre-nosotros">Sobre nosotros</Link>
          <Link to="/contacto">Contacto</Link>
        </nav>

        <section className="public-footer-contact">
          <p>Km 12, ruta al Atlantico, entrada a Usumatlan, Zacapa.</p>
          <p>Tel: 4097-7396</p>
          <p>Correo: admims@maderasdelatlantico.com</p>
        </section>
      </div>

      <div className="public-footer-bottom">
        <p>{currentYear} Maderas del Atlantico, S.A. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default PublicFooter;
